import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { GlobalLoadingService } from '../services/global-loading.service';

export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loadingService = inject(GlobalLoadingService);
  
  // Skip loading if the custom header is present
  if (req.headers.has('X-Skip-Loading')) {
    const modifiedReq = req.clone({
      headers: req.headers.delete('X-Skip-Loading')
    });
    return next(modifiedReq);
  }

  loadingService.showLoader();

  return next(req).pipe(
    finalize(() => {
      loadingService.hideLoader();
    })
  );
};
